export var isMobileTabletResponsive = function isMobileTabletResponsive(size) {
  if (size.length) {
    return size === "tablet" || size === "small" || size === "xsmall";
  }
};
export var objectEqual = function objectEqual(obj1, obj2) {
  return JSON.stringify(obj1) !== JSON.stringify(obj2);
};
export var checkAndSetImgUrl = function checkAndSetImgUrl(evt) {
  evt.target.src = imagePlaceholder;
};
